<mat-card class="configurations-card">
  <mat-card-content>
    <mat-tab-group #tabGroup mat-align-tabs="center">
      <mat-tab label="{{ 'labels.inputs.Global Configurations' | translate }}">
        <LOSx-global-configurations-tab></LOSx-global-configurations-tab>
      </mat-tab>
      @if (isBusinessDateEnabled) {
        <mat-tab label="{{ 'labels.inputs.Business Date' | translate }}">
          <LOSx-business-date-tab></LOSx-business-date-tab>
        </mat-tab>
      }
    </mat-tab-group>
  </mat-card-content>
</mat-card>
